import * as React from 'react';
import { observer } from 'mobx-react';
import BottomNav from '@src/business-components/bottom-nav';
import Page from '@src/components/page';
import useStore from '@src/utils/hooks/use-store';
import GiftStore from './store';

const styles = require('./index.less');
const pageBackground = require('./images/page-background.png');
const discountPageBackground = require('./images/page-background-d.png');
const buyTeamSuccess = require('./images/buy-team-success.png');
const createTeamButton = require('./images/create-team-btn.png');
const buyGiftButton = require('./images/buy-gift-btn.png');
const buyedButton = require('./images/buyed-btn.png');
const pageHeight = 8376;
const purchaseButtonTops = [2204, 3026, 3851, 4676, 5487, 6304, 7131, 7964];
const priceTops = [1715, 2535, 3360, 4184, 4995, 5812, 6638, 7471];
const purchaseCountTops = [2296, 3118, 3943, 4768, 5579, 6414, 7241, 8074];
const cloudGameBonusHours = { 2: 1, 3: 1, 4: 1, 5: 2, 6: 2 };

const getPurchaseButtonStyle = top => ({
  top: `${(top / pageHeight) * 100}%`
});

const Gift = () => {
  const store = useStore(() => new GiftStore());
  const purchasableGifts = store.giftViewModels.slice(1);
  const teamAction = store.teamActionViewModel;

  return (
    <Page className={styles.root}>
      <main
        className={styles.page}
        style={{ backgroundImage: `url(${store.purchasePhase === 'presale' ? discountPageBackground : pageBackground})` }}
        data-price-phase={store.purchasePhase}
        data-purchase-open={store.purchasePhase !== 'closed'}
        aria-label="特惠礼包"
      >
        <div className={styles.giftDescription}>
          <p>
            限新服<strong>【{store.serverName}】</strong>领取
          </p>
          <p>特惠时间：10月8日-10月13日 18:00</p>
          <p>补买时间：10月13日18:01-11月16日23:59</p>
        </div>
        <button
          className={styles.teamPurchaseButton}
          type="button"
          data-state={teamAction.actionState}
          disabled={store.isOrdering || teamAction.actionState === 'team_success'}
          onClick={() => store.handleTeamGiftClick()}
          aria-label={teamAction.actionLabel}
        >
          {teamAction.actionState === 'team_success' ? (
            <img className={styles.teamSuccessArtwork} src={buyTeamSuccess} alt="" />
          ) : teamAction.actionState === 'create_team' ? (
            <img className={styles.createTeamArtwork} src={createTeamButton} alt="" />
          ) : (
            <span>{teamAction.actionLabel}</span>
          )}
        </button>
        {purchasableGifts.map((gift, index) => (
          <React.Fragment key={gift.giftId}>
            {/*{!gift.isPlaceholder && (*/}
            {/*  <span className={styles.price} style={getPurchaseButtonStyle(priceTops[index])}>*/}
            {/*    {gift.pricePhase === 'supplemental' ? '补买价' : '特惠价'}*/}
            {/*    <strong>{gift.displayPrice}</strong>元*/}
            {/*  </span>*/}
            {/*)}*/}
            {!gift.isPlaceholder &&
              cloudGameBonusHours[gift.giftId] && (
                <span className={styles.purchaseBonus} style={getPurchaseButtonStyle(purchaseButtonTops[index] - 40)}>
                  额外赠送{cloudGameBonusHours[gift.giftId]}小时云游戏时长
                </span>
              )}
            <button
              className={styles.purchaseButton}
              style={getPurchaseButtonStyle(purchaseButtonTops[index])}
              type="button"
              data-purchase-gift-id={gift.giftId}
              data-state={gift.actionState}
              disabled={store.isOrdering || gift.actionState === 'purchased'}
              onClick={() => store.handleGiftClick(gift.giftId)}
              aria-label={gift.isPurchased ? `${gift.name || '礼包'}已购买` : `购买${gift.name || '礼包'}`}
            >
              {gift.isPurchased ? (
                <img className={styles.buyedGiftArtwork} src={buyedButton} alt="" />
              ) : (
                !gift.isPlaceholder && <img className={styles.buyGiftArtwork} src={buyGiftButton} alt="" />
              )}
            </button>
            {!gift.isPlaceholder && (
              <span className={styles.purchaseCount} style={getPurchaseButtonStyle(purchaseCountTops[index])}>
                已购买人数：{gift.purchaseCount}
              </span>
            )}
          </React.Fragment>
        ))}
      </main>
      <BottomNav active="GIFT" />
    </Page>
  );
};

export default observer(Gift);
